
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import './editor.scss';

export default function Edit(props) {
	const blockProps = useBlockProps({
		className: 'c4l-expected-feedback'
	});
	const { attributes, setAttributes } = props;
	const { content } = attributes;

	return (
		<div {...blockProps}>
			<RichText
				tagName='div'
				className='c4l-expected-feedback-content'
				multiline='p'
				value={content}
				onChange={(newVal) => setAttributes({ content: newVal })}
				placeholder={__('Type the expected feedback  here', 'expected-feedback')}
			/>
		</div>
	);
}
